<template>
  <div class="phone relative rounded-[2.6rem] bg-gradient-to-b from-zinc-600 via-zinc-800 to-zinc-900 p-[3px] shadow-2xl shadow-black/40">
    <!-- Side buttons -->
    <span class="absolute left-[-3px] top-[16%] h-[5%] w-[3px] rounded-l bg-zinc-700" />
    <span class="absolute left-[-3px] top-[24%] h-[9%] w-[3px] rounded-l bg-zinc-700" />
    <span class="absolute left-[-3px] top-[35%] h-[9%] w-[3px] rounded-l bg-zinc-700" />
    <span class="absolute right-[-3px] top-[28%] h-[14%] w-[3px] rounded-r bg-zinc-700" />

    <!-- Bezel -->
    <div class="relative rounded-[2.45rem] bg-black p-[6px]">
      <!-- Screen -->
      <div class="relative overflow-hidden rounded-[2rem] bg-black">
        <slot />

        <!-- Dynamic island -->
        <span class="absolute left-1/2 top-[1.6%] h-[2.6%] w-[28%] -translate-x-1/2 rounded-full bg-black" />

        <!-- Glass reflection -->
        <span class="pointer-events-none absolute inset-0 bg-gradient-to-br from-white/15 via-transparent to-transparent" />
      </div>
    </div>
  </div>
</template>
